import { Link } from 'react-router-dom';
import CardTitle from './CardTitle';
import RestaurantMeta from './RestaurantMeta';
import generalLogo from './img/general_logo.png';
import generalBanner from './img/general_banner.png';

function applyImgFallback(e, fallbackSrc) {
	const img = e.currentTarget;
	if (!img || !fallbackSrc) return;
	if (img.dataset.fallbackApplied === '1') return;
	img.dataset.fallbackApplied = '1';
	img.src = fallbackSrc;
}

function hasMetaValue(v){
	return v !== undefined && v !== null && String(v).trim() !== '';
}

export default function RestaurantCard({
	to,
	logoSrc,
	imageSrc,
	heroUsesLogo,
	imageAlt,
	title,
	description,
	rating,
	reviewsCount,
	time,
	cuisine
}){
	// When the restaurant has no rating AND no reviews, we move
	// `time · cuisine` up next to the title (inside header-text,
	// i.e. visually to the right of the logo) instead of rendering
	// the separate bottom meta-row. This keeps cards compact and
	// avoids a near-empty row below the name.
	const hasRatingOrReviews = hasMetaValue(rating) || hasMetaValue(reviewsCount);
	const hasTime = hasMetaValue(time);
	const hasCuisine = hasMetaValue(cuisine);
	const showInlineMeta = !hasRatingOrReviews && (hasTime || hasCuisine);

	return <>
		<Link to={to} className='restaurant-card'>
			<div className={`image-wrap${heroUsesLogo ? ' image-wrap--logo-fallback' : ''}`}>
				<img
					src={imageSrc}
					alt={imageAlt}
					loading='lazy'
					onError={(e) => applyImgFallback(e, generalBanner)}
				/>
			</div>
			<div className={`card-body${description ? '' : ' card-body--no-desc'}`}>
				<div className="header-row">
					<img
						className='restaurant-logo'
						src={logoSrc || generalLogo}
						alt={title ? `${title} logo` : 'Restaurant logo'}
						loading='lazy'
						onError={(e) => applyImgFallback(e, generalLogo)}
					/>

					<div className="header-text">
						<div className="title-row">
							<CardTitle>{title}</CardTitle>
						</div>
						{description ? <p className='desc'>{description}</p> : null}
						{showInlineMeta ? (
							<div className='header-row__inline-meta' aria-label='Restaurant info'>
								{hasTime ? <span className='time'>{time}</span> : null}
								{hasTime && hasCuisine ? <span className='seperator' aria-hidden='true'>•</span> : null}
								{hasCuisine ? <span className='cuisine'>{cuisine}</span> : null}
							</div>
						) : null}
					</div>
				</div>

				{!showInlineMeta ? (
					<RestaurantMeta
						rating={rating}
						reviewsCount={reviewsCount}
						time={time}
						cuisine={cuisine}
					/>
				) : null}
			</div>
		</Link>
	</>
}
